import React from "react";
import ProtectedRoute from "./auth/ProtectedRoute";
import { PortalLayout } from "./layout/PortalLayout";

interface ProtectedPortalRouteProps {
  children: React.ReactNode;
}

const ProtectedPortalRoute: React.FC<ProtectedPortalRouteProps> = ({
  children,
}) => {
  return (
    <ProtectedRoute>
      <PortalLayout>{children}</PortalLayout>
    </ProtectedRoute>
  );
};

export default ProtectedPortalRoute;
